<template>
    <sa-page-layout :data="jsonData" :btnBackVisible="true" :showModalLoading="showModalLoading" :linkback="linkback" :pathResource="pathResource" class="sa-no-space">
        <template slot="toolbar"></template>
        <template slot="table-body">
            <svei-configurazione-punti-incontro-view-component @update="onUpdateJsonData"></svei-configurazione-punti-incontro-view-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import SveiConfigurazionePuntiIncontroViewComponent from "../components/SveiConfigurazionePuntiIncontroViewComponent.vue";
export default {
    components: { SaPageLayout, SveiConfigurazionePuntiIncontroViewComponent },
    data() {
        return {
            id: null,
            pathResource: "/sveipuntiincontro",
            linkback: "/sveipuntiincontro",
            showModalLoading: false,
            jsonData: {},
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
    },
    methods: {
        onUpdateJsonData(data) {
            // console.log("OK");
            let me = this;
            me.jsonData = data;
        },
    },
};
</script>

<style></style>
